/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Title4Inputs */

const en_coinvestments_lpdealoverviewcontent_title4 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation Deal Overview Content`)
};

/**
* | output |
* | --- |
* | "Organisation Deal Overview Content" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Title4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_title4 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Title4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Title4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_title4(inputs)
});
export { coinvestments_lpdealoverviewcontent_title4 as "coInvestments_lpDealOverviewContent_title" }